import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto';
import App from './App';
import './i18n/config';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
